import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import RevokeIcon from '../../../../assets/ci/profile/revoke.svg';
import { useSessionID } from '../../../../components/contexts/AccountContextManager';
import SimpleListItem from '../../../../components/SimpleListItem';
import { Container, RevokeButton, StyledCard } from '../styled';
import type useSessionsData from './useSessionsData';

type ActiveSessionsContentProps = {
    data: ReturnType<typeof useSessionsData>['sessionsData'];
    revoke: ReturnType<typeof useSessionsData>['revokeSession'];
};

const ActiveSessionsContent = ({ data, revoke }: ActiveSessionsContentProps) => {
    const { t } = useTranslation('userSelf');
    const currentSessionId = useSessionID();

    return (
        <Container>
            {data.map(session => (
                <StyledCard
                    actions={[
                        <RevokeButton
                            disabled={currentSessionId === session.id}
                            icon={<RevokeIcon />}
                            onClick={() => revoke(currentSessionId)}
                        >
                            {t('userSelf:sessions.revokeButton')}
                        </RevokeButton>,
                    ]}
                >
                    <Space direction="vertical">
                        {session.items.map(item => (
                            <SimpleListItem {...item} />
                        ))}
                    </Space>
                </StyledCard>
            ))}
        </Container>
    );
};

export default ActiveSessionsContent;
